export default __webpack_public_path__ + "images/1774aac2511bd81b5f0a9817511f5fa6-pop_music.webp";